import * as React from 'react';
import cn from 'clsx';

import * as styles from './styles.css';

export interface IPaginationItemProps {
  isActive?: boolean;

  onClick?(): void;
}

export const PaginationItem: React.FC<React.PropsWithChildren<IPaginationItemProps>> = props => {
  return (
    <div
      data-testid="pagination-item"
      className={cn(styles['container'], {
        [styles['container-active']]: props.isActive,
      })}
      onClick={props.onClick}
    >
      <span className={styles['content']}>{props.children}</span>
    </div>
  );
};

PaginationItem.displayName = 'PaginationItem';
